import { useLocation, Link } from "react-router-dom";
import { useSettings } from "@/context/SettingsContext";
import { useAuth } from "@/context/AuthContext";
import { IconGear } from "@/components/icons/Icons";

/** Shows a maintenance screen to visitors when Admin → Sozlamalar → Texnik ishlar is on. Admins pass through. */
export function MaintenanceGate({ children }) {
  const { settings } = useSettings();
  const { isAdmin, status } = useAuth();
  const { pathname } = useLocation();
  const on = settings?.maintenance?.enabled;
  if (!on || isAdmin || status === "loading" || pathname.startsWith("/login") || pathname.startsWith("/admin")) return children;
  return (
    <main className="grid min-h-[100svh] place-items-center px-5" data-testid="maintenance-screen">
      <div className="pk-glass-strong w-full max-w-md rounded-[28px] p-8 text-center">
        <div className="pk-glass mx-auto grid h-16 w-16 place-items-center rounded-[20px] text-white">
          <IconGear size={28} />
        </div>
        <h1 className="mt-5 text-[24px] font-extrabold tracking-[-0.02em] text-white">Texnik ishlar</h1>
        <p className="mt-2 text-[15px] leading-relaxed text-white/60" data-testid="maintenance-message">
          {settings.maintenance.message || "Saytda texnik ishlar olib borilmoqda. Tez orada qaytamiz."}
        </p>
        <Link to="/login" className="mt-6 inline-block text-[13px] font-semibold text-white/40 hover:text-white/70" data-testid="maintenance-admin-login">
          Admin kirishi
        </Link>
      </div>
    </main>
  );
}
